import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorViewComponent } from './color-view.component';



@NgModule({
  declarations: [
    ColorViewComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [ColorViewComponent]
})
export class ColorViewModule { }
